import request from '@/request'

export const getBrand = () => {
  return request({
    url: '/getBrand',
    method: 'post'
  })
}

export const getSeries = () => {
  return request({
    url: '/getSeries',
    method: 'post'
  })
}

export const getPrice = () => {
  return request({
    url: '/getPrice',
    method: 'post'
  })
}
// 省
export const getProvince = data => {
  return request({
    url: '/mobile_SysDd/COMMON_PROVINCE.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 市
export const getCity = data => {
  return request({
    url: '/mobile_SysDd/COMMON_CITY.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 区
export const getCounty = data => {
  return request({
    url: '/mobile_SysDd/COMMON_COUNTY.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 新增问卷区县
export const getDepart = data => {
  return request({
    url: '/intFtuWxcpUser/getDepart.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 问卷地市
export const getCityYzwj = data => {
  return request({
    url: '/mobile_SysDd/FTU_WXCP_DEPARTNEW.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 问卷基地
export const getJdYzwj = data => {
  return request({
    url: '/mobile_SysDd/FTU_QUES_BASE.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 获取性别
export const getSex = data => {
  return request({
    url: '/mobile_SysDd/COMMON_SEX.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 获取开始时间
export const getTime = data => {
  return request({
    url: '/mobile_SysDd/FTU_PARTY_ZTTIME.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 获取信件类型
export const getLetterType = data => {
  return request({
    url: '/mobile_SysDd/FTU_LETTER_TYPE.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 自提地址
export const getSelfAddress = data => {
  return request({
    url: '/mobile_SysDd/FTU_PRODUCT_ORDER_ISSELF_ADDRESS.action',
    method: 'post',
    data,
    isMd5: false
  })
}
